import React from 'react'
import { css } from '@emotion/react'
import { object } from 'prop-types'

import { roundUpWithDecimal } from '@/utils/func'

const ratingWrapperCss = css`
  display: flex;
  flex-wrap: nowrap;
`

const rateCss = css`
  margin-inline: 6px 4px;
`

const starCss = ({ colors }) => css`
  display: block;
  font-size: 12px;
  color: ${colors.gold};
`

const Rating = ({ rating }) => {
  if (!rating) {
    return null
  }

  const decimalRate = roundUpWithDecimal(rating?.rate)

  return (
    <div css={ratingWrapperCss}>
      <span css={rateCss}>
        •&nbsp;&nbsp;
        {decimalRate ?? ''}
      </span>
      <span css={starCss}>★</span>
    </div>
  )
}

Rating.propTypes = {
  rating: object,
}

export default Rating
